import React from 'react';
const UnlockThePower = () => {
    return (
        <div className="section-py bg-grey dark:bg-black">
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-6 grid">
                        <h2 className="text-primary mb-4" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Unlocking the Power of Data with AI and ML
                        </h2>
                        <p
                            className="text-secondary mb-0 dark:text-[#D7DEE5]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200"
                        >
                            In today&apos;s data-driven world, Artificial Intelligence (AI) and Machine Learning (ML) are no longer
                            futuristic concepts; they are powerful tools that can revolutionize your business.
                        </p>
                    </div>
                    <div className="lg:col-span-6 grid">
                        <p
                            className="text-secondary mb-1 dark:text-[#D7DEE5]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200"
                        >
                            At Moweb Limited, we specialize in providing comprehensive AI/ML development services that help
                            businesses leverage the potential of AI to automate processes, enhance decision-making, and improve
                            customer experiences.
                        </p>
                        <p className="text-secondary mb-0 dark:text-[#D7DEE5]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            Whether you&apos;re looking to integrate AI into your existing system or develop a cutting-edge machine
                            learning solution from scratch, our team is here to bring your vision to life.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default UnlockThePower;
